import iconAlmaLinux from './almalinux.svg';
import iconAlpine from './alpine.svg';
import iconArchLinux from './archlinux.svg';
import iconBackup from './backup.svg';
import iconCentOS from './centos.svg';
import iconCloudLinux from './cloudlinux.svg';
import iconCPanel from './cpanel.svg';
import iconCyberPanel from './cyberpanel.svg';
import iconDebian from './debian.svg';
import iconDirectAdmin from './directadmin.svg';
import iconDocker from './docker.svg';
import iconEasyPanel from './easypanel.svg';
import iconGit from './git.svg';
import iconKubernetesK3S from './kubernetes-k3s.svg';
import iconLaravel from './laravel.svg';
import iconMagento from './magento.svg';
import iconMongoDB from './mongodb.svg';
import iconMoodle from './moodle.svg';
import iconN8N from './n8n.svg';
import iconNodeJs from './node-js.svg';
import iconPlesk from './plesk.svg';
import iconPostgreSQL from './postgresql.svg';
import iconPterodactyl from './pterodactyl.svg';
import iconRockyLinux from './rockylinux.svg';
import iconSSHKeys from './ssh-keys.svg';
import iconSOApps from './so-apps.svg';
import iconSnapshot from './snapshot.svg';
import iconSupabase from './supabase.svg';
import iconUbuntu from './ubuntu.svg';
import iconVirtualmin from './virtualmin.svg';
import iconWebmin from './webmin.svg';
import iconWoocommerce from './woocommerce.svg';
import iconWordpress from './wordpress.svg';
import iconWordpress1click from './wordpress-1-clique.svg';
import iconWordpressOls from './wordpress-openlitespeed.svg';
import iconOpenClaw from './openclaw.svg';
import iconGatorClaw from './gatorclaw.svg';
import iconEvolutionApi from './evolutionapi.svg';
import iconEvolutionGo from './evolutiongo.svg';

export const iconMap = {
  almalinux: iconAlmaLinux,
  alpine: iconAlpine,
  archlinux: iconArchLinux,
  backup: iconBackup,
  centos: iconCentOS,
  cloudlinux: iconCloudLinux,
  cpanel: iconCPanel,
  cyberpanel: iconCyberPanel,
  debian: iconDebian,
  directadmin: iconDirectAdmin,
  docker: iconDocker,
  easypanel: iconEasyPanel,
  git: iconGit,
  'kubernetes-k3s': iconKubernetesK3S,
  laravel: iconLaravel,
  magento: iconMagento,
  mongodb: iconMongoDB,
  moodle: iconMoodle,
  n8n: iconN8N,
  'node-js': iconNodeJs,
  openclaw: iconOpenClaw,
  gatorclaw: iconGatorClaw,
  plesk: iconPlesk,
  postgresql: iconPostgreSQL,
  pterodactyl: iconPterodactyl,
  rockylinux: iconRockyLinux,
  'ssh-keys': iconSSHKeys,
  'so-apps': iconSOApps,
  snapshot: iconSnapshot,
  supabase: iconSupabase,
  ubuntu: iconUbuntu,
  virtualmin: iconVirtualmin,
  webmin: iconWebmin,
  woocommerce: iconWoocommerce,
  wordpress: iconWordpress,
  'wordpress-1-clique': iconWordpress1click,
  'wordpress-openlitespeed': iconWordpressOls,
  'evolution-api': iconEvolutionApi,
  'evolution-go': iconEvolutionGo,
};
